<!-- <p>
  customer-general-info works!
</p> -->

<app-card-layout [info]="info" (change)="eventTriggered($event)"></app-card-layout>
